<template>
    <transition name="fade">
      <!-- El popup será visible solo cuando visible sea true -->
      <div v-if="visible" class="fixed">
        <!-- Caja del mensaje de error -->
        <div class="bg-white">
          <div>
            <h2>Información</h2>
            <p>{{ errorMessage }}</p>
            <button @click="closePopup" class="main_button" style="margin-top: 30px;">Entendido</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps } from 'vue';
  
  // Define las props del componente para recibir el mensaje de error
  const props = defineProps({
    errorMessage: String,
  });
  
  const visible = ref(false);
  
  // Hacer visible el popup cuando haya un mensaje de error
  watch(() => props.errorMessage, (newVal) => {
    visible.value = !!newVal;
  });
  
  // Función para cerrar el popup
  const closePopup = () => {
    visible.value = false;
  };
  </script>
  
  <style scoped>
  /* Estilo de transición para suavizar la aparición/desaparición del popup */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  /* Fondo translúcido detrás del popup */
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 50; /* Asegura que el popup esté sobre el contenido */
  }
  
  /* Estilo de la caja que contiene el error */
  .bg-white {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 80%;
    max-width: 400px;
    text-align: center;
  }
  
  </style>
  